// Normalize display spacing without rewriting the saved article or its markup.
export function normalizeArticleSpacing(html: string): string {
  const template = document.createElement('template');
  template.innerHTML = html;
  const root = template.content;
  const preservesWhitespace = (element: Element | null) =>
    Boolean(element?.closest('pre, code'));

  root.querySelectorAll('p, div').forEach((element) => {
    if (
      !preservesWhitespace(element) &&
      !element.textContent?.trim() &&
      !element.querySelector(
        'img, video, audio, iframe, svg, canvas, hr, table',
      )
    ) {
      element.remove();
    }
  });

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode as Text);
  const isBlock = (node: Node | null) =>
    node instanceof Element &&
    /^(P|DIV|H[1-6]|UL|OL|BLOCKQUOTE|TABLE)$/.test(node.tagName);
  textNodes.forEach((node) => {
    if (preservesWhitespace(node.parentElement)) return;
    const text = node.data.replace(/\r\n?/g, '\n');
    if (
      !text.trim() &&
      text.includes('\n') &&
      (isBlock(node.previousSibling) || isBlock(node.nextSibling))
    ) {
      node.remove();
    } else {
      node.data = text.replace(/\n(?:[\t \u00a0]*\n)+/g, '\n');
    }
  });

  root.querySelectorAll('br').forEach((br) => {
    if (preservesWhitespace(br)) return;
    let next = br.nextSibling;
    while (
      next &&
      ((next.nodeType === Node.TEXT_NODE && !next.textContent?.trim()) ||
        (next instanceof Element && next.tagName === 'BR'))
    ) {
      const following = next.nextSibling;
      next.remove();
      next = following;
    }
  });

  // Paragraph margins supply the gap; edge breaks must not add another one.
  root.querySelectorAll('p').forEach((paragraph) => {
    if (preservesWhitespace(paragraph)) return;
    while (
      paragraph.firstChild &&
      ((paragraph.firstChild.nodeType === Node.TEXT_NODE &&
        !paragraph.firstChild.textContent?.trim()) ||
        (paragraph.firstChild instanceof Element &&
          paragraph.firstChild.tagName === 'BR'))
    ) {
      paragraph.firstChild.remove();
    }
    while (
      paragraph.lastChild &&
      ((paragraph.lastChild.nodeType === Node.TEXT_NODE &&
        !paragraph.lastChild.textContent?.trim()) ||
        (paragraph.lastChild instanceof Element &&
          paragraph.lastChild.tagName === 'BR'))
    ) {
      paragraph.lastChild.remove();
    }
  });
  return template.innerHTML;
}
